import type { PublicCheckout } from './contract';

export type CheckoutSkinVariant = 'new' | 'legacy';
export type CheckoutSkinAssignmentSource = 'RANDOM' | 'FORCE_NEW' | 'FORCE_LEGACY' | 'OVERRIDE';

export interface CheckoutSkinDecision {
  readonly variant: CheckoutSkinVariant;
  readonly source: CheckoutSkinAssignmentSource;
}

export function checkoutSkinAssignment(
  sessionId: string,
  mode: NonNullable<PublicCheckout['skin']>['mode'],
  overrideAllowed: boolean,
  override?: string,
): CheckoutSkinDecision {
  if (overrideAllowed && (override === 'new' || override === 'legacy')) return { variant: override, source: 'OVERRIDE' };
  if (mode === 'FORCE_NEW') return { variant: 'new', source: 'FORCE_NEW' };
  if (mode === 'FORCE_LEGACY') return { variant: 'legacy', source: 'FORCE_LEGACY' };
  return { variant: stableBucket(sessionId, 'checkout-skin') < 50 ? 'legacy' : 'new', source: 'RANDOM' };
}

export function checkoutSkinVariant(
  sessionId: string,
  mode: NonNullable<PublicCheckout['skin']>['mode'],
  overrideAllowed: boolean,
  override?: string,
): CheckoutSkinVariant {
  return checkoutSkinAssignment(sessionId, mode, overrideAllowed, override).variant;
}

export function stableBucket(sessionId: string, experimentId: string): number {
  let hash = 0x811c9dc5;
  const value = `${experimentId}:${sessionId}`;
  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index);
    hash = Math.imul(hash, 0x01000193);
  }
  return (hash >>> 0) % 100;
}
